<template>
    <div class="cancel_order">
        <p>确认取消订单吗?</p>
        <div class="btns">
            <van-button round color="var(--theme)" @click="close">再想想</van-button>
            <van-button round color="#e9e9e9" class="confirm" @click="confirm">确认取消</van-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            close() {
                this.$emit('closeModal')
            },
            confirm() {
                this.$emit('success')
            }
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
.cancel_order {
    padding: 2.6rem 1.2rem;
    p {
        color: #555;
        text-align: center;
        font-size: 1.6rem;
        margin-bottom: 2.5rem;
    }
    .btns {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .van-button {
            width: 48%;
            height: 3rem;
            font-size: 1.6rem;
            &.confirm {
                color: #606060 !important;
            }
        }

    }
}
</style>